import React, { useState } from 'react';
import { Formik } from 'formik';

import { FormContainer } from '../../../components';
import { SignUpProcess } from '../../../components/forms/sign-up/sign-up-process';
import {
  externalValidation,
  signUpValidation,
  signUpValidationBusiness,
  signUpValidationIndividual,
} from '../../../validators';
import { ProfileTypeEnum } from '../../../enums/profile-type.enum';
import { OffenderIdentifierType } from '../../../enums';

export const SignUpScreen: React.FC = () => {
  const [signUpType, setSignUpType] = useState(ProfileTypeEnum.both);
  const [formKey, setFormKey] = useState(0);

  const prefilledEmail = sessionStorage.getItem('preSignUpEmail') ?? '';

  return (
    <FormContainer>
      <Formik
        key={formKey}
        validationSchema={
          prefilledEmail.length > 0
            ? externalValidation
            : signUpType === ProfileTypeEnum.both
            ? signUpValidation
            : signUpType === ProfileTypeEnum.individual
            ? signUpValidationIndividual
            : signUpValidationBusiness
        }
        initialValues={{
          account: {
            firstName: '',
            lastName: '',
            email: prefilledEmail,
            confirmEmail: prefilledEmail,
            code: '27',
            cellphone: '',
            password: '',
            confirmPassword: '',
            cellphoneNumber: '',
            termsChecked: true,
            whatsAppOptedIn: false,
            province: '',
          },
          individual: {
            idType: 0,
            idNumber: '',
            identifierType: OffenderIdentifierType.SaIdNumber,
            confirmIdNumber: '',
            familyMembers: [],
          },
          business: {
            businessEntities: [
              {
                entityName: '',
                address: '',
                vatNo: '',
                companyRegistration: '',
                links: [{ value: '', identifierType: OffenderIdentifierType.Brn }],
              },
            ],
          },
        }}
        onSubmit={() => null}
      >
        <SignUpProcess
          setSignUpType={setSignUpType}
          skipToStepSelection={!!prefilledEmail}
          _onFailure={() => {
            setFormKey((prev) => prev + 1);
          }}
        />
      </Formik>
    </FormContainer>
  );
};
